export default "__VITE_ASSET__BqsiJx08__"